import React from 'react';

import { Switch, Route } from 'react-router-dom';

import DashboardLayout from 'components/Layouts/Admin/Dashboard';
import Help from 'components/Pages/Admin/Help';
import PendingContent from 'components/Pages/Admin/PendingContent';
import ResourceLibrary from 'components/Pages/Admin/ResourceLibrary';
// import UsersPage from 'components/Pages/Admin/Users';
import { DocumentLibrary, MediaLibrary } from 'components/Pages/FileLibrary';
import CustomRedirect from 'components/shared/CustomRedirect';
import ErrorScreen from 'components/shared/ErrorScreen';
import Loader from 'components/shared/Loader';
import Title from 'components/shared/Typography/Title';
import * as routes from 'constants/routes';
import { useAccountPath } from 'hooks/useAccountPath';

import SuperAdminRoute from '../SuperAdminRoute';

function DashboardRoutes() {
  const getPath = useAccountPath();

  return (
    <DashboardLayout>
      <Switch>
        {/* It's a hack for show loading while redirecting to SSR */}
        <Route path={routes.DASHBOARD_USERS_PATH} render={() => <Loader isFillBlock />} />

        <SuperAdminRoute path={routes.PENDING_CONTENT_PATH} component={PendingContent} />
        <Route path={routes.CONTENT_LIBRARY_PATH}>
          <CustomRedirect to={getPath(routes.CONTENT_LIBRARY_PATH)} />
        </Route>
        <Route path={routes.RESOURCE_LIBRARY_PATH} component={ResourceLibrary} />
        <Route path={routes.DOCUMENT_LIBRARY_PATH} component={DocumentLibrary} />
        <Route path={routes.MEDIA_LIBRARY_PATH} component={MediaLibrary} />
        <Route path={routes.REFERRALS_PATH} render={() => <PageTitle title="Referrals" />} />
        <Route path={routes.HELP_PATH} component={Help} />
        <Route path={routes.ITINERARIES_PATH}>
          <CustomRedirect to={getPath(routes.ITINERARIES_PATH)} />
        </Route>
        <Route render={() => <ErrorScreen status="404" />} />
      </Switch>
    </DashboardLayout>
  );
}

function PageTitle({ title }) {
  return (
    <div>
      <Title italic level={3} weight="normal" noTransform noMargin>
        {title}
      </Title>
    </div>
  );
}

export default DashboardRoutes;
